/* eslint-disable */
import HttpRequest from '@/services/http-request';

// utilidad file saver
import fileSaver from '@/utils/files/saver';

// moment
import moment from 'moment';

// first we need an asynchronous function that returns a promise
export const getFile = async (url, params = {}, length, name) => {
    // call axios custom streamed download
    return await HttpRequest.get(url, {
        params: params,
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
            // progress event for debug
            const total = length || 1;
            const current = progressEvent.loaded;

            const percentCompleted = Math.floor((current / total) * 100);
            console.log(`${name} completed: `, percentCompleted);
        },
    });
};

export const getAllFiles = async (arrayFiles, zipName = 'archivo', callbackSuccess = null, callbackError = null) => {
    // mapear los archivos en promises
    const all_uris = arrayFiles.map((file) => getFile(file.url, file.params, file.length, file.name));

    //console.log('all_uris', all_uris);

    // zip
    let zip = require('jszip')();

    // ejecutar promise all
    Promise.all(all_uris)
        .then((values) => {
            if (values.length < 2) {
                // un solo archivo
                const response = values[0];

                // datos del response
                const file_data = generateResponseObject(response);

                // see FileSaver.js
                fileSaver(file_data.blob, file_data.name)
            } else {
                // varios archivos
                values.map((response) => {
                    // datos del response
                    const file_data = generateResponseObject(response);

                    // añadimos alñ zip
                    zip.file(file_data.name, file_data.blob);
                });

                // creamos el zip
                zip.generateAsync({type: 'blob'}).then(function (content) {
                    // see FileSaver.js
                    fileSaver(content, createZipName(zipName));
                });
            }

            // llamada a callback
            if (callbackSuccess !== null) callbackSuccess();
        })
        .catch((reason) => {
            // imprimimos el error para debug
            console.error('Ocurrio un error al descargar archivos', reason);

            // llamada acallback de error
            if (callbackError !== null) callbackError();
        });
};

const createZipName = (zipName) => {
    // create zip name if exists
    const currentTime = moment().format('YYYYMMDDHHmmss');
    zipName = zipName.replace(/\s/g, '_');

    return `${currentTime}_${zipName}.zip`;
};

const generateResponseObject = (response) => {
    const blobResponse = response.data;
    let disposition = response.headers['content-disposition'];
    if (disposition === null) {
        disposition = response.headers['Content-Disposition'];
    }
    return {
        blob: blobResponse,
        name: getFileNameDisposition(disposition),
    };
};

const getFileNameDisposition = (disposition) => {
    let filename = '';
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches !== null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
    }

    return filename;
};

export const generateFileUris = (file) => {
    if (file)
        return {
            params: {id: file.file.id},
            length: file.file.size,
            name: file.file.name,
        };

    return;
};
